document.addEventListener('DOMContentLoaded', function() {
  const accountLink = document.querySelector('a.header__icon');

  if (accountLink) {
    // Forcer l’ouverture dans la même tab
    accountLink.setAttribute('target', '_self');

    accountLink.addEventListener('click', function(e) {
      // Force l’ouverture dans la même tab
      e.preventDefault();
      window.location.href = accountLink.href;
    });
  }
});